export const UPDATE_MODEL_EVENT = 'update:modelValue'
export const CHANGE_EVENT = 'change'
export const INPUT_EVENT = 'input'
export const SURE_EVENT = 'sure'
export const CANCEL_EVENT = 'cancel'
